var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "96px",
    height: "100px",
    viewBox: "0 0 96 100",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "loading") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Redirection",
    transform: "translate(-672.000000, -220.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "loading",
    transform: "translate(672.000000, 220.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.1242187,0 C47.6138672,0 45.5787109,2.03515625 45.5787109,4.54550781 L45.5787109,22.7273437 C45.5787109,25.2376953 47.6138672,27.2728516 50.1242187,27.2728516 C52.6345703,27.2728516 54.6697266,25.2376953 54.6697266,22.7273438 L54.6697266,4.54550781 C54.6697266,2.03515625 52.6345703,0 50.1242187,0 Z",
    id: "Path",
    fill: "#2D50A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1246094,72.7273438 C47.6142578,72.7273438 45.5791016,74.7625 45.5791016,77.2728516 L45.5791016,95.4546875 C45.5791016,97.9650391 47.6142578,100.000195 50.1246094,100.000195 C52.6349609,100.000195 54.6701172,97.9650391 54.6701172,95.4546875 L54.6701172,77.2728516 C54.6701172,74.7625 52.6349609,72.7273438 50.1246094,72.7273438 Z",
    id: "Path",
    fill: "#73A1FB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0537109,27.5015625 L21.1970703,14.6445312 C19.4224609,12.8693359 16.5443359,12.8693359 14.7689453,14.6445312 C12.99375,16.4197266 12.99375,19.2976562 14.7689453,21.0726562 L27.6255859,33.9296875 C28.5130859,34.8171875 29.6765625,35.2611328 30.8394531,35.2611328 C32.0025391,35.2611328 33.1662109,34.8171875 34.0533203,33.9296875 C35.8289062,32.1544922 35.8289062,29.2767578 34.0537109,27.5015625 Z",
    id: "Path",
    fill: "#355EC9"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.843750, 45.312500)",
    fill: "#C4D9FD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1896484,0.141992188 L17.0988281,0.141992188 C14.5884766,0.141992188 12.5533203,2.17714844 12.5533203,4.6875 C12.5533203,7.19785156 14.5884766,9.23300781 17.0988281,9.23300781 L26.1896484,9.23300781 C28.7,9.23300781 30.7351563,7.19785156 30.7351563,4.6875 C30.7351563,2.17714844 28.7,0.141992188 26.1896484,0.141992188 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77929687,20.7583984 C6.00449219,18.9832031 3.12636719,18.9835938 1.35117188,20.7583984 C-0.424023437,22.5335938 -0.423632812,25.4113281 1.35117188,27.1865234 L14.2082031,40.0429688 C15.0957031,40.9304687 16.2591797,41.3742187 17.4224609,41.3742187 C18.5857422,41.3742187 19.7492188,40.9302734 20.6363281,40.0429688 C22.4115234,38.2677734 22.4115234,35.3898437 20.6363281,33.6148437 L7.77929687,20.7583984 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M27.3970703,50 C27.3970703,47.4896484 25.3619141,45.4544922 22.8515625,45.4544922 L4.66972656,45.4544922 C2.159375,45.4544922 0.12421875,47.4896484 0.12421875,50 C0.12421875,52.5103516 2.159375,54.5455078 4.66972656,54.5455078 L22.8515625,54.5455078 C25.3619141,54.5455078 27.3970703,52.5103516 27.3970703,50 Z",
    id: "Path",
    fill: "#3D6DEB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0537109,66.0708984 C32.2789063,64.2957031 29.4005859,64.2957031 27.6255859,66.0708984 L14.7691406,78.9273438 C12.9939453,80.7021484 12.9939453,83.5804688 14.7691406,85.3554688 C15.6566406,86.2429688 16.8201172,86.6867187 17.9833984,86.6867187 C19.1466797,86.6867187 20.3101562,86.2431641 21.1972656,85.3554688 L34.0537109,72.4990234 C35.8289063,70.7242188 35.8289063,67.8460938 34.0537109,66.0708984 Z",
    id: "Path",
    fill: "#5286FA"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.688ef733.svg";
export { ForwardRef as ReactComponent };